"use client";

import React, { type ReactNode, createContext, useContext } from "react";

import { type ActiveSearchParams, useSearch } from "@/hooks/useSearch";
import type { SearchQueryItem } from "@/lib/shop-agent-client";

interface SearchContextType {
  recentSearches: SearchQueryItem[];
  activeSearchParams: ActiveSearchParams;
  updateSearchParam: <K extends keyof ActiveSearchParams>(
    key: K,
    value: ActiveSearchParams[K]
  ) => void;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export const SearchProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const searchState = useSearch();

  return <SearchContext.Provider value={searchState}>{children}</SearchContext.Provider>;
};

export const useSearchContext = (): SearchContextType => {
  const context = useContext(SearchContext);
  if (context === undefined) {
    throw new Error("useSearchContext must be used within a SearchProvider");
  }
  return context;
};
